import type { IconDef } from '../types';

export const keyboard: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '2',
    },
    {
      d: 'M6 7h2v2H6zM10 7h2v2h-2zM14 7h2v2h-2zM6 11h2v2H6zM10 11h2v2h-2zM14 11h2v2h-2zM8 15h6v1.5H8z',
    },
  ],
};
